import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";

export default function Recognitions() {
  const [awards, setAwards] = useState([]);

  useEffect(() => {
    axios
      .post(`${API_BASE_URL}/api/aboutus/getAboutUs`, { service_tag: "about" })
      .then((response) => {
        const data =
          response?.data?.data?.about_us?.about_us_recognitions_data || [];
        setAwards(data);
      })
      .catch(() => {
        setAwards([]);
      });
  }, []);

  if (awards.length === 0) {
    return null;
  }

  return (
    <div className="home-recognitions section-space">
      <div className="container">
        <div className="home-recognitions__head">
          <h2 className="home-recognitions__heading">
            Recognitions &amp; Awards 
          </h2>
          <p className="home-recognitions__subtitle">
            25 years of excellence, recognized by industry bodies, technology partners, and government
            institutions for our commitment to innovation and service quality.
          </p>
        </div>

        <div className="home-recognitions__grid">
          {awards.slice(0, 8).map((award, index) => (
            <div className="recognition-card" key={award.id || index}>
              <span className="recognition-card__photo">
                <img
                  src={award.image}
                  alt={award.altText || award.title}
                  loading="lazy"
                  decoding="async"
                />
              </span>
              <h3 className="recognition-card__title">{award.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
